import * as React from "react";

import { assertNever } from "@impero-com/common/utils/obj";

import { BaseFormDisplay } from "./formDisplay";

interface LinkInputProps {
    label: string;
    linkName: string;
    action: LinkAction;
}

interface Link {
    type: "LINK";
    linkTo: string;
}

interface Click {
    type: "CLICK";
    onClick: () => void;
}

type LinkAction = Link | Click;

class FormLink extends React.PureComponent<LinkInputProps> {
    render() {
        const { linkName, action } = this.props;

        let anchorElement: React.ReactNode;
        switch (action.type) {
            case "LINK":
                anchorElement = <a href={action.linkTo}>{linkName}</a>;
                break;
            case "CLICK":
                anchorElement = <a onClick={action.onClick}>{linkName}</a>;
                break;
            default:
                assertNever(action);
        }

        return (
            <BaseFormDisplay label={this.props.label}>
                {anchorElement}
            </BaseFormDisplay>
        );
    }
}

export { FormLink };
